// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconFolder = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 20V10C12 8.76593 12.7659 8 14 8H22.6863C25.0568 8 26.6669 8.66693 28.3431 10.3431L29.6569 11.6569C31.3331 13.333 32.9432 14 35.3137 14H50C51.2341 14 52 14.7659 52 16V20C52 21.2341 51.2341 22 50 22H14C12.7659 22 12 21.2341 12 20ZM53.9982 26H10.0018C8.74586 26 7.97627 26.7972 8.00056 28.0529C8.22138 39.465 10.2299 48.0118 11.3063 51.8176C11.7152 53.2635 12.6908 54 14.1934 54H49.8066C51.3092 54 52.2848 53.2635 52.6937 51.8176C53.7701 48.0118 55.7786 39.465 55.9995 28.0529C56.0238 26.7972 55.2542 26 53.9982 26Z" />
    </svg>
  );
};
